import React, { useContext } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import Verified from "../../assets/images/Verified.svg";
import Camera from "../../assets/images/Camera.svg";
import SubmitButton from "../Buttons/SubmitButton";
import CancelButton from "../Buttons/CancelButton";
import { set, useForm } from "react-hook-form";
import { redirectToRealMe } from "../../Services/apiService";
import Loader from "../Loader/Loader";
import { verifyArs } from "../../Services/applicationService";
import FieldError from "../FieldError/index.jsx";
import {
  getCountryByLabel,
  getValueFromLabel,
} from "../../Services/localStorage.tsx";
import { AppContext } from "../../contexts/AppContext.jsx";
import {
  initiateApplication,
  updateApplication,
  getApplication,
} from "../../Services/applicationService"; // import the save function
import { AlreadySubmittedError } from "../../Utils/Errors.tsx";
import { calculateAge } from "../../Services/localStorage.tsx"; // Assuming you have a utility function for calculating age
import { useNavigate } from "react-router-dom";
import { toTitleCase } from "../../Utils/stringHandler.tsx"; // Assuming you have a utility function for title case

const RenewIdentity = ({ handleNext, handleCancel }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onTouched",
  });

  const navigate = useNavigate();

  const { appState, setAppState, userFlows, userRegister, setUserFlows } =
    useContext(AppContext);

  const onSubmit = async () => {
    setIsLoading(true);
    const vFormData = {
      register: "verified-identity",
      arsId: userRegister?.registerKey || "",
    };
    try {
      const resp = await verifyArs(vFormData, navigate);
      console.log("Verification response:", resp);
      const country = resp.countryOfBirth;
      console.log("Country of birth:", country);
      const countryId = await getCountryByLabel(country);
      console.log("Country ID:", countryId);

      const gender = resp.gender;
      const genderId = await getValueFromLabel("GenderReference", gender);

      const age = calculateAge(resp.dateOfBirth);
      let applicationTypeId = "dee0075c-6dcd-ef11-b8e9-00224891c497";
      if (age < 14) applicationTypeId = "fee0075c-6dcd-ef11-b8e9-00224891c497";

      const updatedAppState = {
        ...appState,
        requestPayload: {
          ...appState.requestPayload,
          applicationTypeId: applicationTypeId,
          applicationFlowCode: 100000001,
          applicant: {
            ...appState.requestPayload.applicant,

            givenNames: (
              resp?.personName?.givenNames +
              " " +
              (resp?.personName?.middleNames || "")
            ).trim(),
            familyName: resp?.personName?.familyName,
            dateOfBirth: resp.dateOfBirth,
            placeOfBirth: toTitleCase(resp.placeOfBirth),
            genderId: genderId,
            countryOfBirthId: countryId?.dia_countryid,
            namesKnownAs: [
              {
                nameTypeId: "3ecbc107-c3b8-e911-a866-000d3ae10c61",
                familyName: resp?.personName?.familyName,
                givenNames: (
                  resp?.personName?.givenNames +
                  " " +
                  (resp?.personName?.middleNames || "")
                ).trim(),
              },
            ],
          },
          eventTypeSearch: [
            {
              eventTypeId: "6e17a9e2-ccef-ef11-be1f-7c1e528a0d00",
              documentNumber: resp.registerKey,
              familyName: resp?.personName?.familyName,
              givenNames: (
                resp?.personName?.givenNames +
                " " +
                (resp?.personName?.middleNames || "")
              ).trim(),
              dateOfBirth: resp.dateOfBirth,
              countryOfBirthId: countryId?.dia_countryid,
              genderId: genderId,
            },
          ],
        },
      };
      // console.log("Updated application state:", updatedAppState);
      if (updatedAppState.requestPayload.applicationId) {
        updateApplication(updatedAppState.requestPayload)
          .then((response) => {
            console.log("Application updated successfully:", response);
            setAppState(updatedAppState);
            setUserFlows({
              ...userFlows,
              isRenew: true,
            });
            setIsLoading(false);
            handleNext();
          })
          .catch((error) => {
            setIsLoading(false);
            if (!(error instanceof AlreadySubmittedError)) {
              navigate("/app/something-went-wrong");
            }
          });
      } else
        initiateApplication(updatedAppState.requestPayload)
          .then((response) => {
            console.log("Application initiated successfully:", response);
            updatedAppState.requestPayload.applicationId = response.serviceId;
            setAppState(updatedAppState);
            setUserFlows({
              ...userFlows,
              isRenew: true,
            });
            setIsLoading(false);
            handleNext();
          })
          .catch((error) => {
            console.error("Error initiating application:", error);
            setIsLoading(false);
            navigate("/app/something-went-wrong");
          });

      // handleNext();
    } catch (error) {
      console.error("Error during verification:", error);
      navigate("/app/something-went-wrong");
    } finally {
      console.log("Finally block executed");
    }
  };

  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <>
      {isLoading && <Loader />}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro renew-identity">
          {/* <Progress progress={0} /> */}
          <h1 className="intro-title-mi" lang="mi-NZ">
            Whakahoutia tō tuakiri hāpono
          </h1>
          <hr />
          <h1 className="intro-title">Renew your verified identity</h1>
          <div className="step-container">
            <p className="step-text">
              Your verified identity needs to be renewed every 10 years.
            </p>
          </div>
          <div className="step-container">
            <h2 className="step-title mb-4">How it works </h2>
            <div className="step-wrapper">
              <div className="step-imgbx">
                <img src={Verified} alt="Verified" />
              </div>
              <div>
                <h2 className="step-heading mb-2">
                  1. Tell us about any changes
                </h2>
                <p className="step-text">
                  Confirm your current details such as name and gender.
                </p>
              </div>
            </div>
            <div className="step-wrapper align-items-center">
              <div className="step-imgbx">
                <img src={Camera} alt="camera" />
              </div>
              <h2 className="step-heading mb-0">
                2. Take a live photo using your device
              </h2>
            </div>
          </div>
          <h2 className="step-title mb-2">Terms of use</h2>
          <div className="checkbox-wrapper">
            <input
              type="checkbox"
              id="terms-checkbox"
              className="terms-check"
              {...register("terms", {
                required: "You must accept the terms to proceed.",
              })}
            />
            <label className="terms-label" htmlFor="terms-checkbox">
              I accept the{" "}
              <a href="https://www.realme.govt.nz/terms-use/identity-verification-service-terms-use/">
                RealMe Verified Identity Terms of use
              </a>
              <span className="req-text">*</span>
            </label>
          </div>
          {errors?.terms && <FieldError error={errors?.terms} info={null} />}
        </div>
        <div className="step-button-container spacer-64">
          <SubmitButton
            text={"Get Started"}
            type="submit"
            disabled={!isValid}
          />
          <CancelButton text={"Cancel"} onClick={redirectToRealMe} />
        </div>
      </form>
    </>
  );
};

export default RenewIdentity;
